import moment from 'moment';

// Vuex
import {mapActions, mapGetters} from 'vuex';

// Components
import ComplaintsTab from '@/views/Appointment/Form/ComplaintsTab';
import PatientTab from '../../Patient/Detail/InformationTab/PersonalInfoTab';
import MedicalHistoryTab from '@/views/Appointment/Form/MedicalHistoryTab';
import SocialHistoryTab from '@/views/Appointment/Form//SocialHistoryTab';
import VitalsTab from '@/views/Appointment/Form//Vitals';
import DiagnosisTab from '@/views/Appointment/Form//DiagnosisTab';
import NotesTab from '@/views/Appointment/Form//NotesTab';
import PrescriptionTab from '../../Prescription/PrescriptionList';
import LabExamTab from '@/views/Appointment/Form//LabExam';

import Notification from '@/views/Common/Notification';

// Mixins
import NotificationMixin from '@/mixins/notification';

// Constants
import * as FCFS from '@/store/constants/fcfs';
import * as APPOINTMENT from '@/store/constants/appointment';
import * as VITAL from '@/store/constants/vital';
import * as USER from '@/store/constants/user';

export default {
  inject: ['$validator'],
  components: {
    PatientTab,
    LabExamTab,
    VitalsTab,
    ComplaintsTab,
    MedicalHistoryTab,
    SocialHistoryTab,
    DiagnosisTab,
    NotesTab,
    PrescriptionTab,
    Notification
  },
  mixins: [NotificationMixin],
  data() {
    return {
      tabs: [
        {key: 'patient-tab', text: 'Patient Info'},
        {key: 'complaints-tab', text: 'Reason for Consultation'},
        // {key: 'medical-history-tab', text: 'Medical History'},
        // {key: 'social-history-tab', text: 'Social History'},
        {key: 'vitals-tab', text: 'Vitals'},
        {key: 'diagnosis-tab', text: 'Diagnosis'},
        {key: 'notes-tab', text: 'Notes'},
        {key: 'prescription-tab', text: 'Prescription'},
        // {key: 'lab-exam-tab', text: 'Lab Exam'}
      ],
      tabIndex: 0,
      queue_id: null,
      patient: {},
      queue: {},
      mode: 'add',
      original_appointment: {},
      appointment: {
        vital: {}
      },
      setting: {
        place: 'Test Place.'
      }
    }
  },

  computed: {
    ...mapGetters({
      user: USER.GET_USER
    }),

    /**
     * We need to make sure that we have diagnosis and recommendation before the user can generate
     * a medical certificate.
     *
     * @returns {boolean}
     */
    can_generate_certificate() {
      return this.appointment.id !== undefined;
    }
  },

  methods: {
    ...mapActions({
      getQueue: FCFS.ACTION_GET_QUEUE,
      updateQueue: FCFS.ACTION_UPDATE_QUEUE,
      addAppointment: APPOINTMENT.ACTION_ADD,
      getAppointment: APPOINTMENT.ACTION_GET_APPOINTMENT,
      updateAppointment: APPOINTMENT.ACTION_UPDATE,
      addVital: VITAL.ACTION_ADD,
      updateVital: VITAL.ACTION_UPDATE,
    }),

    addOrUpdateVital(vital, original) {
      return (!original)
        ? this.addVital(vital)
        : this.updateVital(vital);
    },

    /**
     * Associate vital data to appointment.
     *
     * @returns {Promise<void>}
     */
    async associateVitalId() {
      if (this.canSaveVitalData()) {
        const vital = await this.addOrUpdateVital(this.appointment.vital, this.original_appointment.vital);
        this.appointment = {...this.appointment, ...{vital_id: vital.data.id}};
      }
    },

    /**
     * Handle updating of appointment.
     */
    handleUpdateAppointment() {
      this.associateVitalId().then(() => {
        this.updateAppointment(this.appointment).then(() => {
          this.showSuccessNotification('Appointment successfully updated.');
        });
      });
    },

    /**
     * Handle adding of appointment.
     */
    handleAddAppointment() {
      this.resetNotification();
      this.associateVitalId().then(() => {
        this.addAppointment(this.appointment).then(res => {
          this.updateQueue({
            id: this.queue.id,
            payload: {appointment_id: res.data.id}
          });

          this.appointment.id = res.data.id;

          // Set the mode to edit.
          this.mode = 'edit';
          this.queue.appointment_id = res.data.id;

          this.showSuccessNotification('Appointment successfully added.');
        }).catch(e => this.showErrorNotification(e.response.data));
      });
    },

    /**
     * Can save vital data?
     * @returns {boolean}
     */
    canSaveVitalData() {
      return Object.keys(this.appointment.vital).length > 0;
    },

    /**
     * Store information.
     */
    save() {
      this.resetNotification();

      this.$validator.validateAll().then(res => {
        if (res) {
          (this.mode === 'add' && this.appointment)
            ? this.handleAddAppointment()
            : this.handleUpdateAppointment();
        } else {
          this.showErrorNotification('Please correct all invalid inputs.');
        }
      }).catch(e => {
        this.showErrorNotification(e.message);
      })
    },

    /**
     * Is Queue has an appointment?
     *
     * @param queue
     * @returns {*|null}
     */
    hasAppointment(queue) {
      return (queue.appointment_id);
    },

    prepareAppointmentPayload() {
      this.appointment = {
        ...this.appointment, ...{
          patient_id: this.queue.patient_id,
          doctor_id: this.queue.doctor_id,
          patient_name: `${this.patient.first_name} ${this.patient.last_name}`,
          appointment_date: moment().format('YYYY-MM-DD')
        }
      };
    },

    /**
     * Refresh appointment data.
     */
    refreshData() {
      this.getQueue(this.queue_id).then(res => {
        this.queue = res.data;
        this.patient = res.data.patient;

        if (this.hasAppointment(this.queue)) {
          this.mode = 'edit';

          // Load the appointment detail.
          this.getAppointment(this.queue.appointment_id).then(res => {
            this.original_appointment = res.data;

            this.appointment = {...this.appointment, ...res.data};

            if (this.appointment.vital === null) this.appointment.vital = {}
          });
        } else {
          this.prepareAppointmentPayload();
        }
      });
    },
  },

  created() {
    this.queue_id = this.$route.params['id'];
    this.refreshData();
  }
}



// WEBPACK FOOTER //
// ./src/views/FCFS/js/fcfs-detail.js